import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTrigger } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";

export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  size = "md",
  destructive = false,
  warning = false,
  isLoading = false,
  confirmDisabled = false,
  content,
  children,
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  description?: string;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  size?: "sm" | "md" | "lg";
  destructive?: boolean;
  warning?: boolean;
  isLoading?: boolean;
  confirmDisabled?: boolean;
  content?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}
      <DialogContent size={size} {...(!description ? { "aria-describedby": undefined } : {})}>
        <DialogHeader title={title} description={description} />
        {content}
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange?.(false)}>
            {cancelLabel}
          </Button>
          <Button
            variant={destructive ? "danger" : warning ? "warning" : "primary"}
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading || confirmDisabled}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
